import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Newspaper, Mail, Construction } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PressPage = () => {
  const { i18n } = useTranslation();

  return (
    <main className="min-h-screen pt-20 pb-16">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center py-16"
        >
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
            <Newspaper className="w-10 h-10 text-primary" />
          </div>
          
          <h1 className="text-4xl font-bold mb-4">
            {i18n.language === 'fr' ? 'Presse' : 'Press'}
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8">
            {i18n.language === 'fr' 
              ? 'Espace presse et médias'
              : 'Press and media space'}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl p-12 text-center border border-orange-200"
        >
          <div className="w-20 h-20 rounded-full bg-orange-100 flex items-center justify-center mx-auto mb-6">
            <Construction className="w-10 h-10 text-orange-500" />
          </div>
          
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            {i18n.language === 'fr' 
              ? 'Page en construction'
              : 'Page under construction'}
          </h2>
          
          <p className="text-muted-foreground mb-8 max-w-md mx-auto">
            {i18n.language === 'fr'
              ? 'Notre espace presse sera bientôt disponible avec nos communiqués, kit média et actualités.'
              : 'Our press space will soon be available with our press releases, media kit and news.'}
          </p>

          <div className="bg-white rounded-xl p-6 max-w-md mx-auto border border-orange-200">
            <h3 className="font-semibold mb-2">
              {i18n.language === 'fr' ? 'Contact Presse' : 'Press Contact'}
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              {i18n.language === 'fr'
                ? 'Pour toute demande presse, contactez-nous'
                : 'For any press inquiries, contact us'}
            </p>
            <Button variant="outline" asChild>
              <a href="mailto:press@xperience-guides.com">
                <Mail className="w-4 h-4 mr-2" />
                press@xperience-guides.com
              </a>
            </Button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-12 text-center text-sm text-muted-foreground"
        >
          <p>
            {i18n.language === 'fr'
              ? 'Bientôt disponible : communiqués de presse, kit média, logos et photos haute résolution.'
              : 'Coming soon: press releases, media kit, logos and high resolution photos.'}
          </p>
        </motion.div>
      </div>
    </main>
  );
};

export default PressPage;
